export default __webpack_public_path__ + "static/media/(28).8e6bf32c.jpeg";